module.exports = __webpack_public_path__ + "static/media/synth_15.e5275ae8.mp3";